export default __webpack_public_path__ + "static/media/LoginImage.229479bb.png";